// 柱
import rlModel from "./rlModel";
import store from "@/store/index";

class rlColumn extends rlModel {
  constructor() {
    super();
    this.componentType = "column";
    // 顶点数据
    this.points = [];
    this.Name = null;

    this.m_JointData = {}; //关联的节点数据
    // this.m_sectParamData = {}; //柱截面数据
    // this.SectData = []; //柱截面组合数据

    this.EccX = null; //柱的沿轴偏心--沿X轴
    this.EccY = null; //柱的偏轴偏心--沿Y轴
    this.Rotation = null; //柱转角
    this.HDiffB = null; //柱底标高

    this.Attribute = 1; //默认为主要构件
    this.classTypeName = "rlColSeg"; // 柱
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    // this.defaultColor = "#0201f9"; //默认颜色
    this.Color = "#ffff00";
    // (this.rlLayer && this.rlLayer[1] && this.rlLayer[1].storey) || "#0201f9"; //构件颜色
    // this.Layer = "rlColSeg"; //图层名称
    this.ModelType = "柱";
    this.m_groupName = "rlColumnGroup"; //组名
    this.m_sectGroupName = ""; //截面字符
    // wasm接口方法
    this.getPKPM_ColData =
      store.state.globalData.rl_wasm_module.getPKPM_ColData;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);

    this.m_JointData = obj.m_JointData;
    this.EccX = obj.EccX;
    this.EccY = obj.EccY;
    this.Rotation = obj.Rotation;
    this.HDiffB = obj.HDiffB;
    this.Color = obj.Color ? obj.Color : "#ffff00";
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_JointData = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_JointData);
    this.EccX = obj.EccX;
    this.EccY = obj.EccY;
    this.Rotation = obj.Rotation;
    this.HDiffB = obj.HDiffB;
  }
  // 添加
  add(obj) {
    const beamParams = obj.beamParams;

    this.ID = obj.ID;
    this.Name = obj.Name;
    this.Guid = obj.Guid;

    this.rlFloorData = obj.rlFloorData;

    this.m_JointData = obj.m_JointData;
    this.m_sectParamData = obj.m_sectParamData;

    this.EccX = beamParams.EccX;
    this.EccY = beamParams.EccY;
    this.Rotation = beamParams.Rotation;
    this.HDiffB = beamParams.HDiffB;

    this.LevelB = beamParams.LevelB;
    this.Height = Number(beamParams.Height);
    this.ModelNo = obj.ModelNo;

    this.Color = beamParams.Color ? beamParams.Color : "#ffff00";
    this.Layer = beamParams.Layer ? beamParams.Layer : "rlColSeg";
    this.Strength = obj.Strength ? obj.Strength : null;
    this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
  }

  // 数据转换
  convert() {
    let res = this.getPKPM_ColData(
      this.m_sectParamData.Kind,
      this.m_sectParamData.ShapeVal,
      this.m_JointData.m_pt[0],
      this.m_JointData.m_pt[1],
      this.LevelB,
      this.Height,
      this.EccX,
      this.EccY,
      this.Rotation,
      this.HDiffB
    );

    this.getModelDrawData(JSON.parse(res));

    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
    }
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    this.points = modelData.Points;
    this.index3dData = modelData["3D"]["3dFaces"]
      .map((item) => item.index)
      .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
  }

  // 删除
  erase() {
    this.m_JointData ? (this.m_JointData.m_cloumId = null) : "";
    super.erase();
  }

  // 克隆方法
  async myClone() {
    let newObj = await super.myClone();

    newObj.EccX = this.EccX;
    newObj.EccY = this.EccY;
    newObj.Rotation = this.Rotation;
    newObj.HDiffB = this.HDiffB;

    newObj.points = this.points;
    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    // let wObj;
    this.convert();
    if (pWorldDraw.mxObj._is2d) {
      // wObj = this.create2dModel(this.index2dData);
      // wObj.material.color.set(this.Color);
      pWorldDraw.setColor(new THREE.Color(this.Color));
      this.create2dModel(this.index2dData, pWorldDraw);
    }

    this._threeObj = this.create3dModel(
      this.points,
      this.index3dData,
      0.00006,
      10
    );

    if (this.m_JointData) {
      this.m_JointData.m_cloumId = this.objectId();
    }

    // pWorldDraw.drawEntity(wObj);

    // this.statusType=2;
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;
    if (this.m_JointData) data["JtGuid"] = this.m_JointData.Guid;

    data["EccX"] = this.EccX;
    data["EccY"] = this.EccY;
    data["Rotation"] = this.Rotation;
    data["HDiffB"] = this.HDiffB;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();
    data["m_JointData"] = this.m_JointData.objectId();
    data["EccX"] = this.EccX;
    data["EccY"] = this.EccY;
    data["Rotation"] = this.Rotation;
    data["HDiffB"] = this.HDiffB;
    return data;
  }
  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    return true;
  }
}

export { rlColumn };
